// extracted by mini-css-extract-plugin
export default {"goal-list":"GoalList_goal-list__kDXOr"};